import MuiButton from './MuiButton';
import MuiTable from './MuiTable';
import MuiPaginationItem from './MuiPaginationItem';
import MuiSlider from './MuiSlider';
import MuiSwitch from './MuiSwitch';
import MuiCard from './MuiCard';
import MuiPaper from './MuiPaper';
import MuiDivider from './MuiDivider';

const components = {
  MuiButton,
  MuiTable,
  MuiPaginationItem,
  MuiSlider,
  MuiSwitch,
  MuiCard,
  MuiPaper,
  MuiDivider,
};

export default components;

